var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-10"},[_c('div',{staticClass:"_fs-36"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._v(_vm._s(_vm.subtitle))]),(_vm.title || _vm.subtitle)?_c('v-divider',{staticClass:"my-4"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }